import { PaymentApiModule } from '@adeo/ngx-kozikaza-api/payment';
import { NgModule } from '@angular/core';
import { KozikashService } from './kozikash.service';

@NgModule({
  imports: [
    PaymentApiModule,
  ],
  providers: [
    KozikashService,
  ],
})
export class KozikashModule {

}
